import { render, staticRenderFns } from "./ResearchReportTextList.vue?vue&type=template&id=92f0627a&scoped=true"
import script from "./ResearchReportTextList.vue?vue&type=script&lang=js"
export * from "./ResearchReportTextList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f0627a",
  null
  
)

export default component.exports